import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { rp } from "../../lib/format";

export const Barcode = ({ value, height = 40, width = 1.6, fontSize = 12 }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      const fmt = /^\d{13}$/.test(value) ? "EAN13" : "CODE128";
      JsBarcode(ref.current, value, { format: fmt, height, width, fontSize, margin: 0, displayValue: true, background: "transparent" });
    } catch (e) {
      JsBarcode(ref.current, value, { format: "CODE128", height, width, fontSize, margin: 0 });
    }
  }, [value, height, width, fontSize]);
  return value ? <svg ref={ref} className="max-w-full" /> : <div className="text-[10px] italic">tanpa barcode</div>;
};

export const LABEL_SIZES = {
  receipt: { label: "Ikuti lebar kertas struk", w: null, h: null },
  "50x30": { label: "Label 50 x 30 mm", w: "50mm", h: "30mm" },
  "40x30": { label: "Label 40 x 30 mm", w: "40mm", h: "30mm" },
  "33x15": { label: "Label 33 x 15 mm (kecil)", w: "33mm", h: "15mm" },
  a4: { label: "Kertas A4 (grid)", w: "48mm", h: "28mm" },
};

export const Label = ({ l, store, opts }) => {
  const size = LABEL_SIZES[opts.size || "receipt"];
  const small = opts.size === "33x15";
  return (
    <div className="bg-white text-black flex flex-col items-center justify-center text-center overflow-hidden px-1"
      style={{ width: size.w || "100%", height: size.h || "auto", padding: size.h ? "1mm" : "3mm 1mm", breakInside: "avoid", pageBreakInside: "avoid" }}>
      {opts.showStore && !small && <div className="text-[8px] leading-none mb-0.5">{store?.store_name}</div>}
      {opts.showName && <div className={`font-bold leading-tight line-clamp-2 ${small ? "text-[7px]" : "text-[10px]"}`}>{l.name}</div>}
      <Barcode value={l.barcode} height={small ? 16 : 34} width={small ? 1 : 1.4} fontSize={small ? 8 : 11} />
      {opts.showPrice && <div className={`font-bold font-mono leading-none mt-0.5 ${small ? "text-[8px]" : "text-sm"}`}>{rp(l.price)}</div>}
    </div>
  );
};

export const LabelSheet = ({ labels, store, opts, print = false }) => {
  const size = opts.size || "receipt";
  const receiptW = store?.receipt_width === "80mm" ? "72mm" : "48mm";
  if (size === "a4")
    return (
      <div className="grid grid-cols-4 gap-[2mm] bg-white" style={{ width: print ? "200mm" : "100%", padding: print ? "5mm" : 0 }} data-testid="label-sheet">
        {labels.map((l, i) => <div key={i} className="border border-dashed border-black/30"><Label l={l} store={store} opts={opts} /></div>)}
      </div>
    );
  const w = size === "receipt" ? receiptW : LABEL_SIZES[size].w;
  return (
    <div className="flex flex-col items-center bg-white" style={{ width: print ? w : "100%" }} data-testid="label-sheet">
      {labels.map((l, i) => (
        <div key={i} style={{ width: w, pageBreakAfter: size !== "receipt" && print ? "always" : "auto" }} className={size === "receipt" ? "border-b border-dashed border-black/40" : print ? "" : "mb-2 border border-dashed border-black/30"}>
          <Label l={l} store={store} opts={opts} />
        </div>
      ))}
    </div>
  );
};
